(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wo-collection-card"] && !Shopify.designMode) return;
  try {
    (() => {
    function syncCollectionInstallments() {
      document.querySelectorAll('.wo-card-installments').forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        const terms = form.querySelector('shopify-payment-terms');
        if (!input || !terms || !input.value) return;
        terms.setAttribute('variant-id', input.value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncCollectionInstallments);
    } else {
      syncCollectionInstallments();
    }
    document.addEventListener('shopify:section:load', syncCollectionInstallments);
  })();
  } catch(e) { console.error(e); }
})();

})();
